import {get, chunk} from "lodash"
import Papa from "papaparse"

import userService from "@irati/identity/services/users"
import teamService from "@irati/identity/services/teams"
import {promiseSerialAll} from "@irati/utils/promise"
import FormatMessage from "@irati/utils/lang/types/FormatMessage"
import {EMAIL} from "@irati/admin/helpers/userCSV"
import { TeamAssignment } from "@irati/types"

interface FailedUser {
  email: string,
  message: string
}

const assignUsersToTeamByCSV = (file: File, formatMessage: FormatMessage, businessUuid: string, usersRole: TeamAssignment, createdTeamId?: string) => {
  return new Promise((resolve) => {
    Papa.parse(file, {
      header: false,
      skipEmptyLines: true,
      complete: (results: any) => {
        const failedUsers: FailedUser[] = []
        let assignedManagers = 0
        const chunks = chunk<string>(results.data.filter((row) => row[0] !== EMAIL), 10)

        return teamService.list(businessUuid, {}, {fetchPolicy: "network-only"}).then((teams) => {
          const funcs = chunks.map((userChunk) => () => {
            return Promise.all(
              userChunk.map((row) => {
                const email = row[0]
                return userService
                  .getUserByEmail(email, businessUuid, {fetchPolicy: "network-only"})
                  .then((user) => {
                    if (user) {
                      if (createdTeamId) {
                        const addedAsManager = user.teamAssignments?.find((t) => t.teamId === createdTeamId && t.assignment === TeamAssignment.Manager)

                        if (addedAsManager) {
                          return failedUsers.push({
                            email,
                            message: formatMessage({id: "platform.assignManagers.errors.alreadyAddedAsManager"})
                          })
                        }
                      }
                      const teamUuid = teams.find((team) => createdTeamId ? team.uuid === createdTeamId : team.teamName === row[1])?.uuid

                      if (teamUuid) {
                        return teamService
                          .addUserToTeam(teamUuid, user.uuid, usersRole)
                          .then(() => {
                            assignedManagers++
                          })
                      }
                      if (createdTeamId) {
                        return failedUsers.push({
                          email,
                          message: formatMessage({id: "platform.assignManagers.errors.createdTeamDoesNotExist"})
                        })
                      }
                      const team = row[1]
                      return failedUsers.push({
                        email,
                        message: formatMessage({id: "platform.assignManagers.errors.teamDoesNotExist"}, {team})
                      })
                    }
                    failedUsers.push({
                      email,
                      message: formatMessage({id: "platform.assignManagers.errors.userDoesNotExist"})
                    })
                  })
                  .catch((err) => {
                    const message = get(err, "response.data.message", formatMessage({id: "platform.assignManagers.errors.default"}))
                    failedUsers.push({
                      email,
                      message
                    })
                  })
              })
            )
          })
          return promiseSerialAll(funcs).then(() => resolve({assignedManagers, failedUsers}))

        })
      }
    })
  })
}

export default assignUsersToTeamByCSV
